import { App } from "vue";
import { instance } from "@/instance";

declare module "vue" {
    interface ComponentCustomProperties {
        $instance: typeof instance;
    }
}

export function injectGlobalProperties<T>(app: App<T>) {
    app.config.globalProperties = {
        ...app.config.globalProperties,
        $instance: instance,
    };
}
